/**
 * @file
 * Patria header links functionality
 */

(function ($, Drupal) {

  'use strict';

  const globalToggle = $('.global-toggle');
  const countrySitesToggle = $('.country-sites-toggle');
  const togglesWrapper = $('.navigation-left__toggles');
  const navigationRegion = $('.region-navigation');

  // If toggles do not exist, do nothing.
  if (!globalToggle.length || !countrySitesToggle.length) {
    return;
  }

  /**
   * Opens the country-sites picker panel and marks its tab active.
   *
   * @return {void}
   */
  function openPicker() {
    navigationRegion.addClass('picker-open');
    countrySitesToggle.addClass('active');
    globalToggle.removeClass('active');
  }

  /**
   * Closes the country-sites picker panel and restores the global tab.
   *
   * @return {void}
   */
  function closePicker() {
    navigationRegion.removeClass('picker-open');
    globalToggle.addClass('active');
    countrySitesToggle.removeClass('active');
  }

  // Country sites toggle opens the picker panel (replacing the site's own menu)
  countrySitesToggle.on('click', function () {
    if (navigationRegion.hasClass('picker-open')) {
      closePicker();
    } else {
      openPicker();
    }
  });

  // Global toggle is a pure state toggle (never a link): while the picker
  // is open, clicking it closes the picker and switches back to the site's
  // own main menu panel. Otherwise it's just a "you are here" indicator.
  globalToggle.on('click', function () {
    if (navigationRegion.hasClass('picker-open')) {
      closePicker();
    }
  });

  // Listen for click events on body to close the picker when clicked outside
  document.body.addEventListener('click', function (event) {
    if (navigationRegion.hasClass('picker-open')) {
      const isClickInside = togglesWrapper[0].contains(event.target);
      if (!isClickInside) {
        closePicker();
      }
    }
  });

})(jQuery, Drupal);
